import baseApi, {
    transformResponseFromData,
    provideTags,
    provideTag,
} from 'store/slices/api/baseApi'

const usersApi = baseApi.injectEndpoints({
    endpoints: (build) => ({
        getUsers: build.query({
            query: () => ({url: 'users', method: 'GET'}),
            transformResponse: transformResponseFromData,
            providesTags: (result) => provideTags('User', result),
        }),
        getUser: build.query({
            query: ({userId}) => ({
                url: `users/${userId}`,
                method: 'GET',
            }),
            transformResponse: transformResponseFromData,
            providesTags: (result) => provideTag('User', result),
        }),
        saveUser: build.mutation({
            query: (user) => {
                console.log('save user mutation req', user)
                return {
                    url: 'Provision/userdetails/',
                    method: 'PUT',
                    body: user,
                }
            },
            transformResponse: transformResponseFromData,
            invalidatesTags: (result) => [
                ...provideTag('User', result),
                'CurrentUser',
            ],
        }),
        // deleteUser: build.mutation({
        //     query: ({userId}) => {
        //         console.log('delete user mutation req', userId)
        //         return {
        //             url: `users/${userId}`,
        //             method: 'DELETE',
        //         }
        //     },
        //     transformResponse: transformResponseFromData,
        //     invalidatesTags: () => provideTag('User'),
        // }),
        saveCreditCard: build.mutation({
            query: (body) => {
                return {
                    url: 'Planner/postTranzilaCC',
                    method: 'POST',
                    body,
                }
            },
            transformResponse: transformResponseFromData,
            invalidatesTags: () => provideTag('User'),
        }),
    }),
    overrideExisting: false,
})

export default usersApi

export const {
    useGetUserQuery,
    useGetUsersQuery,
    useSaveUserMutation,
    // useDeleteUserMutation,
    useSaveCreditCardMutation,
} = usersApi
